export default __webpack_public_path__ + "static/media/weather.5a2ea775.jpg";